const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(
      window.location.hostname
    )
);

type Config = {
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if (!("serviceWorker" in navigator)) return;

  const publicUrl = new URL(
    (process as { env: { [key: string]: string } }).env.PUBLIC_URL,
    window.location.href
  );

  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener("load", () => {
    const baseURL = (process as { env: { [key: string]: string } }).env
      .PUBLIC_URL;
    const swUrls = [
      `${baseURL}/service-worker.js`,
      `${baseURL}/firebase-messaging-sw.js`,
    ];

    swUrls.forEach((swUrl) => {
      if (isLocalhost) {
        validateServiceWorker(swUrl, config);
        logDevInfo();
      } else {
        registerValidSW(swUrl, config);
      }
    });
  });
}

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              config?.onUpdate?.(registration);
            } else {
              config?.onSuccess?.(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error(`[SW ERROR] Failed to register: ${swUrl}`, error);
    });
}

function validateServiceWorker(swUrl: string, config?: Config) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const isValid =
        response.status !== 404 &&
        response.headers.get("content-type")?.includes("javascript");

      if (!isValid) {
        navigator.serviceWorker.getRegistration(swUrl)?.then((registration) => {
          registration?.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.warn(`[SW] No internet connection or invalid SW: ${swUrl}`);
    });
}

function logDevInfo() {
  navigator.serviceWorker.ready.then(() => {});
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => reg.unregister());
    });

    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("✅ Service Worker registered:", registration);
      })
      .catch((err) => {
        console.error("❌ Service Worker registration failed:", err);
      });
  }
}
